import { useEffect, useState } from "react";
import {
  EvidencingFragment,
  ResourceEvidencingState,
} from "~/graphql/codegen/graphql";
import { useIsAuthenticated } from "~/hooks/context-hook";
import { graphql } from "~/graphql/codegen";
import { useSubscription } from "@apollo/client/react";

const EVIDENCE_POINTS_SUBSCRIPTION = graphql(`
  subscription EvidencePoints($articleID: ID) {
    articlePointsUpdated(articleID: $articleID) {
      ...evidencing
    }
  }
`);

export default function useEvidencing(
  resourceID?: string,
  existing?: EvidencingFragment,
): EvidencingFragment {
  const authenticated = useIsAuthenticated();
  const emptyState = {
    state: ResourceEvidencingState.NoData,
    totalEarnedPoints: 0,
    totalEarnablePoints: 0,
    totalPassiveEarnedPoints: 0,
    totalPassiveEarnablePoints: 0,
    totalTriviaEarnablePoints: 0,
    totalTriviaEarnedPoints: 0,
    passiveDetails: [],
    triviaDetails: [],
    score: {
      total: 0,
    },
  };
  const [state, setState] = useState(existing || emptyState);

  useSubscription(EVIDENCE_POINTS_SUBSCRIPTION, {
    variables: {
      articleID: resourceID,
    },
    skip: !authenticated || !resourceID,
    onData: (d) => {
      if (d.data.error) {
        console.error("websocket error: ", d.data.error);
      }
      const evidencing = d.data.data?.articlePointsUpdated;
      if (evidencing) {
        setState(evidencing);
      } else {
        console.error("evidencing error", d.data.error);
      }
    },
  });

  useEffect(() => {
    if (existing) setState(existing);
  }, [existing, resourceID]);

  return state;
}
